import * as React from 'react';
import Main from './main';
import { CircularProgress } from '@mui/material';

export default function App() {
  return (
    <React.Suspense fallback={<CircularProgress />}>
      <Main />
    </React.Suspense>
  );
}
